/* OS EDD - Top Shop Flavors REV (scoped, no globals) */
(() => {
  const SELECTOR_ROOT = '[data-os-edd-top-shop-flavors-rev]';
  const SELECTOR_CTA = '[data-oseddflavorsrev-cta]';
  const SELECTOR_STICKY = '[data-oseddflavorsrev-sticky]';
  const SELECTOR_PRE_STICKY = '[data-oseddflavorsrev-pre-sticky]';
  const SELECTOR_STICKY_CTA = '[data-oseddflavorsrev-sticky-cta]';
  const SELECTOR_PRE_STICKY_CTA = '[data-oseddflavorsrev-pre-sticky-cta]';
  const SELECTOR_REVEAL_BTN = '[data-oseddflavorsrev-reveal-btn]';

  function parseDiscountCodes(raw) {
    const text = (raw || '').trim();
    if (!text) return [];
    // Accept comma or newline separated
    return text
      .split(/[\n,]+/g)
      .map((s) => s.trim())
      .filter(Boolean);
  }

  async function postJSON(url, bodyObj) {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(bodyObj),
      credentials: 'same-origin',
    });

    const contentType = res.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const data = isJson ? await res.json() : await res.text();

    if (!res.ok) {
      const msg =
        (data && (data.description || data.message)) ||
        (typeof data === 'string' ? data : 'Request failed');
      throw new Error(msg);
    }

    return data;
  }

  async function addItemsBatch(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ items: items || [] }),
      credentials: 'same-origin',
      cache: 'no-store',
    });

    const contentType = res.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const data = isJson ? await res.json() : await res.text();

    if (!res.ok) {
      const msg =
        (data && (data.description || data.message)) ||
        (typeof data === 'string' ? data : 'Request failed');
      throw new Error(msg);
    }

    return data;
  }

  async function addSingleItem(item) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(item || {}),
      credentials: 'same-origin',
      cache: 'no-store',
    });

    const contentType = res.headers.get('content-type') || '';
    const isJson = contentType.includes('application/json');
    const data = isJson ? await res.json() : await res.text();

    if (!res.ok) {
      const msg =
        (data && (data.description || data.message)) ||
        (typeof data === 'string' ? data : 'Request failed');
      throw new Error(msg);
    }

    return data;
  }

  function wait(ms) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, ms);
    });
  }

  function setStatus(root, msg) {
    const el = root.querySelector('[data-oseddflavorsrev-status]');
    if (!el) return;
    el.textContent = msg || '';
  }

  function getScrollOffsetPx() {
    // If your theme header is visible/sticky, account for it.
    // If header is hidden (like your CSS), this will end up 0.
    try {
      const header = document.querySelector('.header-wrapper');
      if (!header) return 0;

      const style = window.getComputedStyle(header);
      if (style.display === 'none' || style.visibility === 'hidden') return 0;

      // Only offset if it’s fixed/sticky (common for Shopify headers)
      const pos = (style.position || '').toLowerCase();
      if (pos !== 'fixed' && pos !== 'sticky') return 0;

      const h = Math.round(header.getBoundingClientRect().height || 0);
      return Math.max(0, h);
    } catch (e) {
      return 0;
    }
  }

  function smoothScrollToTarget(targetEl) {
    if (!targetEl) return;

    const offset = getScrollOffsetPx();
    const rect = targetEl.getBoundingClientRect();
    const y = Math.round(window.pageYOffset + rect.top - offset - 12); // 12px breathing room

    window.scrollTo({
      top: Math.max(0, y),
      behavior: 'smooth',
    });
  }

  function bindInfoDropdowns(root) {
    const items = root.querySelectorAll('.oseddflavorsrev-topshop__infoItem');
    if (!items || !items.length) return;

    items.forEach((item) => {
      const btn = item.querySelector('[data-oseddflavorsrev-info-btn]');
      const panel = item.querySelector('[data-oseddflavorsrev-info-panel]');
      if (!btn || !panel) return;

      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        // Close all siblings (accordion behavior)
        items.forEach((sib) => {
          if (sib === item) return;
          sib.classList.remove('is-open');
          const sibBtn = sib.querySelector('[data-oseddflavorsrev-info-btn]');
          const sibPanel = sib.querySelector('[data-oseddflavorsrev-info-panel]');
          if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
          if (sibPanel) sibPanel.hidden = true;
        });

        if (isOpen) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  function bindFlavorSwitcher(root) {
    const select = root.querySelector('[data-oseddflavorsrev-flavor-select]');

    if (select && !select.__oseddflavorsrevFlavorBound) {
      select.__oseddflavorsrevFlavorBound = true;

      select.addEventListener('change', () => {
        const nextUrl = (select.value || '').trim();
        if (!nextUrl) return;

        window.location.href = nextUrl;
      });
    }

    const radios = root.querySelectorAll('[data-oseddflavorsrev-flavor-radio]');
    if (!radios || !radios.length) return;

    radios.forEach((radio) => {
      if (radio.__oseddflavorsrevFlavorRadioBound) return;
      radio.__oseddflavorsrevFlavorRadioBound = true;

      radio.addEventListener('keydown', (e) => {
        const key = e.key || '';

        if (key === ' ' || key === 'Spacebar') {
          e.preventDefault();
          radio.click();
        }

        if (key === 'Enter') {
          e.preventDefault();
          radio.click();
        }
      });
    });
  }

  function bindRteScrollLinks(root) {
    // Only handle anchor links inside this section’s RTE areas
    const rteContainers = root.querySelectorAll(
      '.oseddflavorsrev-topshop__awardBody.rte, .oseddflavorsrev-topshop__offerBody.rte, .oseddflavorsrev-topshop__awardBodyImgRight.rte'
    );
    if (!rteContainers || !rteContainers.length) return;

    rteContainers.forEach((wrap) => {
      wrap.addEventListener('click', (e) => {
        const a = e.target && e.target.closest ? e.target.closest('a') : null;
        if (!a) return;

        const href = (a.getAttribute('href') || '').trim();
        if (!href || href === '#') return;

        // Only intercept same-page hash links (e.g. #reviews)
        if (href.charAt(0) !== '#') return;

        const id = href.slice(1);
        if (!id) return;

        const target = document.getElementById(id);
        if (!target) return;

        e.preventDefault();
        smoothScrollToTarget(target);

        // Optional: keep URL hash in sync without jumping
        try {
          history.pushState(null, '', `#${id}`);
        } catch (err) {}
      });
    });
  }

  function setStickyVisible(root, isVisible) {
    if (!root) return;

    const sticky = root.querySelector(SELECTOR_STICKY);
    const preSticky = root.querySelector(SELECTOR_PRE_STICKY);

    const revealEnabled = root.getAttribute('data-oseddflavorsrev-reveal-enabled') === '1';
    const isRevealed = root.classList.contains('oseddflavorsrev-revealed');

    if (revealEnabled && !isRevealed) {
      root.classList.remove('oseddflavorsrev-sticky-active');

      if (sticky) {
        sticky.setAttribute('aria-hidden', 'true');
      }

      if (isVisible) {
        root.classList.add('oseddflavorsrev-pre-sticky-active');
        if (preSticky) preSticky.setAttribute('aria-hidden', 'false');
      } else {
        root.classList.remove('oseddflavorsrev-pre-sticky-active');
        if (preSticky) preSticky.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    root.classList.remove('oseddflavorsrev-pre-sticky-active');
    if (preSticky) {
      preSticky.setAttribute('aria-hidden', 'true');
    }

    if (!sticky) return;

    if (isVisible) {
      root.classList.add('oseddflavorsrev-sticky-active');
      sticky.setAttribute('aria-hidden', 'false');
    } else {
      root.classList.remove('oseddflavorsrev-sticky-active');
      sticky.setAttribute('aria-hidden', 'true');
    }
  }

  function bindStickyObserver(root, mainCta) {
    if (!root || !mainCta) return;

    // Avoid double-binding observers
    if (root.__oseddflavorsrevStickyObserved) return;
    root.__oseddflavorsrevStickyObserved = true;

    // Fallback if IO not supported
    if (!('IntersectionObserver' in window)) {
      const onScroll = () => {
        const r = mainCta.getBoundingClientRect();
        const inView = r.bottom > 0 && r.top < window.innerHeight;
        setStickyVisible(root, !inView);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
      return;
    }

    const obs = new IntersectionObserver(
      (entries) => {
        const entry = entries && entries[0];
        if (!entry) return;

        // Show sticky when main CTA is not sufficiently visible
        const inView = entry.isIntersecting && entry.intersectionRatio >= 0.25;
        setStickyVisible(root, !inView);
      },
      {
        root: null,
        threshold: [0, 0.25, 0.5, 1],
      }
    );

    obs.observe(mainCta);
    root.__oseddflavorsrevStickyObs = obs;
  }

  function setBusy(btn, isBusy) {
    if (!btn) return;
    btn.disabled = !!isBusy;
    btn.setAttribute('aria-busy', isBusy ? 'true' : 'false');

    if (isBusy) btn.classList.add('is-busy');
    else btn.classList.remove('is-busy');
  }

  function explodeConfetti(root) {
    if (!root) return;

    const layer = root.querySelector('[data-oseddflavorsrev-confetti-layer]');
    if (!layer) return;

    layer.innerHTML = '';

    const colors = ['#ec0387', '#f7c85b', '#7ee7f3', '#ffffff', '#000000'];
    const piecesCount = 44;

    for (let i = 0; i < piecesCount; i += 1) {
      const piece = document.createElement('span');
      piece.className = 'oseddflavorsrev-topshop__confettiPiece';

      const spreadX = Math.round((Math.random() * 2 - 1) * 380);
      const spreadY = Math.round(-150 - Math.random() * 300);
      const rotate = Math.round((Math.random() * 2 - 1) * 720);
      const delay = Math.round(Math.random() * 110);
      const width = 8 + Math.round(Math.random() * 7);
      const height = 12 + Math.round(Math.random() * 12);

      piece.style.setProperty('--oseddflavorsrev-confetti-x', `${spreadX}px`);
      piece.style.setProperty('--oseddflavorsrev-confetti-y', `${spreadY}px`);
      piece.style.setProperty('--oseddflavorsrev-confetti-r', `${rotate}deg`);
      piece.style.background = colors[i % colors.length];
      piece.style.width = `${width}px`;
      piece.style.height = `${height}px`;
      piece.style.animationDelay = `${delay}ms`;

      layer.appendChild(piece);
    }

    window.setTimeout(() => {
      layer.innerHTML = '';
    }, 1400);
  }

  function revealOfferCard(root) {
    if (!root || root.classList.contains('oseddflavorsrev-revealed')) return;

    explodeConfetti(root);
    root.classList.add('oseddflavorsrev-revealed');

    window.setTimeout(() => {
      const mainCta = root.querySelector(SELECTOR_CTA);
      if (mainCta && root.__oseddflavorsrevStickyObserved) {
        const r = mainCta.getBoundingClientRect();
        const inView = r.bottom > 0 && r.top < window.innerHeight;
        setStickyVisible(root, !inView);
      }
    }, 340);
  }

  function bindRevealWall(root) {
    if (!root) return;

    const revealEnabled = root.getAttribute('data-oseddflavorsrev-reveal-enabled') === '1';
    if (!revealEnabled) return;

    const revealBtn = root.querySelector(SELECTOR_REVEAL_BTN);
    if (!revealBtn) return;

    revealBtn.addEventListener('click', () => {
      revealOfferCard(root);
    });
  }

  async function handleCheckoutClick(btn) {
    const root = btn.closest(SELECTOR_ROOT);
    if (!root) return;

    if (root.__oseddflavorsrevCheckoutSubmitting) return;
    root.__oseddflavorsrevCheckoutSubmitting = true;

    const mainCta = root.querySelector(SELECTOR_CTA);
    const stickyCta = root.querySelector(SELECTOR_STICKY_CTA);

    setStatus(root, '');
    setBusy(mainCta, true);
    setBusy(stickyCta, true);

    try {
      const clearCart = btn.getAttribute('data-oseddflavorsrev-clear-cart') === '1';
      const mainVariantIdRaw = (btn.getAttribute('data-oseddflavorsrev-main-variant') || '').trim();
      const mainQty = Number(btn.getAttribute('data-oseddflavorsrev-main-qty') || 1);
      const mainSellingPlanRaw = (btn.getAttribute('data-oseddflavorsrev-main-selling-plan') || '').trim();

      const mainVariantId = Number(mainVariantIdRaw || 0);
      const mainSellingPlanId = Number(mainSellingPlanRaw || 0);

      if (!mainVariantId) {
        throw new Error('Missing main variant ID. Please set it in the section settings.');
      }

      let freebies = [];
      const freebiesRaw = btn.getAttribute('data-oseddflavorsrev-freebies') || '[]';

      try {
        freebies = JSON.parse(freebiesRaw) || [];
      } catch (e) {
        freebies = [];
      }

      const mainItem = {
        id: mainVariantId,
        quantity: Math.max(1, mainQty || 1),
      };

      if (mainSellingPlanRaw && mainSellingPlanId > 0) {
        mainItem.selling_plan = mainSellingPlanId;
      }

      const freebieItems = (freebies || [])
        .filter((it) => it && Number(it.id) > 0)
        .map((it) => ({
          id: Number(it.id),
          quantity: Math.max(1, Number(it.quantity) || 1),
        }));

      const discountCodes = parseDiscountCodes(btn.getAttribute('data-oseddflavorsrev-discounts'));
      const checkoutUrl =
        discountCodes.length > 0
          ? `/checkout?discount=${encodeURIComponent(discountCodes.join(','))}`
          : '/checkout';

      if (clearCart) {
        await postJSON('/cart/clear.js', {});
        await wait(180);
      }

      await addSingleItem(mainItem);

      if (freebieItems.length) {
        try {
          await addItemsBatch(freebieItems);
        } catch (freebieErr) {
          console.warn('OS EDD flavors rev freebies failed to add:', freebieErr);
        }
      }

      window.location.href = checkoutUrl;
      return;
    } catch (err) {
      const msg = err && err.message ? err.message : 'Unable to start checkout. Please try again.';
      setStatus(root, msg);
      setBusy(mainCta, false);
      setBusy(stickyCta, false);
      root.__oseddflavorsrevCheckoutSubmitting = false;
    }
  }

  function bindRoot(root) {
    if (!root || root.__oseddflavorsrevBound) return;
    root.__oseddflavorsrevBound = true;

    const cta = root.querySelector(SELECTOR_CTA);
    if (cta) {
      cta.addEventListener('click', () => handleCheckoutClick(cta));
    }

    const stickyCta = root.querySelector(SELECTOR_STICKY_CTA);
    if (stickyCta) {
      stickyCta.addEventListener('click', () => handleCheckoutClick(stickyCta));
    }

    const preStickyCta = root.querySelector(SELECTOR_PRE_STICKY_CTA);
    if (preStickyCta) {
      preStickyCta.addEventListener('click', () => {
        const offerCard = root.querySelector('.oseddflavorsrev-topshop__offerCard');

        revealOfferCard(root);

        window.setTimeout(() => {
          smoothScrollToTarget(offerCard || root);
        }, 20);
      });
    }

    // Show sticky CTA only when main CTA scrolls out of view
    if (cta) {
      bindStickyObserver(root, cta);
    }

    // Reveal wall click handler
    bindRevealWall(root);

    // Dropdown info accordions (desktop + mobile placements)
    bindInfoDropdowns(root);

    // Flavor page switcher
    bindFlavorSwitcher(root);

    // Smooth-scroll for hash links inside RTE content (award/offer richtext)
    bindRteScrollLinks(root);

    // If primary flavor is sold out, redirect to fallback flavor URL
    const oseddrevFlavorSwitch = root.querySelector('.oseddflavorsrev-topshop__flavorSwitch');
    if (oseddrevFlavorSwitch) {
      const oseddrevRedirectUrl = (oseddrevFlavorSwitch.getAttribute('data-oseddflavorsrev-redirect') || '').trim();
      if (oseddrevRedirectUrl) {
        const oseddrevCurrentPath = window.location.pathname + window.location.search;
        const oseddrevRedirectPath = oseddrevRedirectUrl.split('?')[0];
        if (oseddrevCurrentPath.indexOf(oseddrevRedirectPath) === -1) {
          window.location.replace(oseddrevRedirectUrl);
          return;
        }
      }
    }

    // Gallery: main image switch + thumb strip with side arrows
    const gallery = root.querySelector('[data-oseddflavorsrev-gallery]');
    const mainSlides = root.querySelectorAll('[data-oseddflavorsrev-gal-main-slide]');
    const thumbs = root.querySelectorAll('[data-oseddflavorsrev-thumb]');
    const thumbViewport = root.querySelector('[data-oseddflavorsrev-thumb-viewport]');
    const thumbList = root.querySelector('[data-oseddflavorsrev-thumb-list]');
    const mainPrev = root.querySelector('[data-oseddflavorsrev-main-nav="prev"]');
    const mainNext = root.querySelector('[data-oseddflavorsrev-main-nav="next"]');

    // If thumbs exist, move the main-nav buttons down to sit beside the thumbs row (CSS handles positioning)
    if (root.querySelector('.oseddflavorsrev-topshop__galThumbs')) {
      root.classList.add('oseddflavorsrev-has-thumbs');
    } else {
      root.classList.remove('oseddflavorsrev-has-thumbs');
    }

    if (gallery && mainSlides.length && thumbs.length) {
      let index = 0;

      const syncMainNav = () => {
        if (!mainPrev || !mainNext) return;
        const max = Math.max(0, mainSlides.length - 1);
        mainPrev.disabled = index <= 0;
        mainNext.disabled = index >= max;
      };

      const setActive = (nextIndex) => {
        const max = Math.max(0, mainSlides.length - 1);
        index = Math.min(Math.max(nextIndex, 0), max);

        mainSlides.forEach((s, i) => {
          const isActive = i === index;
          s.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          if (isActive) s.setAttribute('data-oseddflavorsrev-active', '1');
          else s.removeAttribute('data-oseddflavorsrev-active');
        });

        thumbs.forEach((t, i) => {
          const isActive = i === index;
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive) t.setAttribute('data-oseddflavorsrev-active', '1');
          else t.removeAttribute('data-oseddflavorsrev-active');
        });

        // Keep active thumb in view (NO centering -> prevents half-cut thumbs)
        const activeThumb = thumbs[index];
        if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }

        syncMainNav();
      };

      thumbs.forEach((t) => {
        t.addEventListener('click', () => {
          const i = Number(t.getAttribute('data-oseddflavorsrev-gal-index') || 0);
          setActive(i);
        });
      });

      if (mainPrev) {
        mainPrev.addEventListener('click', (e) => {
          if (e && typeof e.preventDefault === 'function') e.preventDefault();
          setActive(index - 1);
        });
      }

      if (mainNext) {
        mainNext.addEventListener('click', (e) => {
          if (e && typeof e.preventDefault === 'function') e.preventDefault();
          setActive(index + 1);
        });
      }

      // Keep thumbs usable with native horizontal scrolling
      if (thumbViewport) {
        thumbViewport.style.scrollBehavior = 'smooth';
      }

      void thumbList;
    }
  }

  function init() {
    document.querySelectorAll(SELECTOR_ROOT).forEach(bindRoot);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();